import { Box, styled } from '@mui/material';
import { ActionNodeData } from '../../../mappers/map-canvas-content.types';

export const ActionNodeContent = ({ data }: { data: ActionNodeData }) => {
  const options = data.value;
  const isPopulated = options.length > 0;

  if (!isPopulated) {
    return <Description>Configure this action node.</Description>;
  }

  return (
    <ContentWrapper>
      <Description>Action node configuration:</Description>
      <PillsWrap>
        {options.map((option) => (
          <Pill key={option.value}>{option.label}</Pill>
        ))}
      </PillsWrap>
    </ContentWrapper>
  );
};

const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const Description = styled(Box)(() => ({
  fontSize: 10,
}));

const PillsWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
}));

const Pill = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(2),
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  fontSize: 10,
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
}));
